export default __webpack_public_path__ + "static/image_evenement-3d907db70524a3521b0d8a9f427b4ea7.jpg";